
import { getRootVariable } from '../../services/service-utils';
import { ChartColors } from '../../consts/const-utils';


export const setChartScaleTitle = (titleOptional) =>
{ 
  return  {
    display: true,
    text: titleOptional ? titleOptional : "Kr. pr. time",
    font: {
      weight: 'bold',
    },
    padding: 20
  }
}


export const setXScaleProps = (gridDisplay) =>
{ 
  return  {
    min: 0,  
    title: setChartScaleTitle(),
    ticks:
    {
      autoSkip: true,
      autoSkipPadding: 100,
      maxRotation: 0,
      major: {
        enabled: true
      },
      padding: 10,
    },
    grid: {
      display: gridDisplay ? gridDisplay : true,
      drawBorder: false,
      drawOnChartArea: true,
      drawTicks: false,
      
/*       color: (context) => {
        return context.tick.value == 0 ? "rgba(0,0,0,0)" : "#737373";
      } */
    },
  }
}

export const updateSalaryLegendStyle = (el, salaryGroup) =>
{ 
  var salaryLegend = el.querySelector(`.salary-legend-container`);
  if(salaryLegend)
  {
    const listItems = salaryLegend.querySelectorAll("li");
    listItems && listItems.forEach(l => {
      if(l.getAttribute("data-salary") != salaryGroup)
      {
        l.classList.remove("selected")
      }
      else{
        l.classList.add("selected")
      }        
    });
  }

}